export const loginURL = {
    baseURL: 'https://user-oneid.deep-time.org',
    
    appCode: 'htg',

    domain: 'deep-time.org',

    secretCode: 'vbco1xljy91lbozetlmdhyafqx55fndw',

    login: '/ngiam-rst/v1/sdk/login/sso',

    tokenChange: '/loginToDDE/ngiam-rst/oauth2/token',

    infoChange: '/loginToDDE/ngiam-rst/oauth2/userinfo',

    validate: '/loginToDDE/ngiam-rst/oauth2/validate',

    exit: '/ngiam-rst/cas/logout',
}